import React, { useState } from "react";
import {
  Accordion as DsmAccordion,
  Typography,
  Modal,
  Button,
  CircularLoader,
  Icon,
  Tooltip,
} from "@plum-xoxo/admin-dsm";
import StatusChip from "../components/StatusChip";
import styled from "styled-components";
import moment from "moment";
import { isLinkResendable, isLinkCancellable } from "../../../utils/reports";
import reportService from "../../../services/reportService";
import Date from "../components/Date";
import ToolTipText from "../components/ToolTipText";
import { NotificationManager } from "react-notifications";
import { getRewardType } from "./utils";
const ViewDetailModal = styled(Modal).attrs()`
  height: 100vh;
  margin-right: 0;
  border-radius: 0;
`;

const Accordion = styled(DsmAccordion).attrs()`
  .view-detail-accordain-item {
    box-shadow: none;
  }
  .view-detail-accordain-item > div {
    padding: 8px 12px;
    border-radius: 0px;
    font-size: 12px;
    background: #f6f6f7;
  }
  .eui-accordion-title {
    font-weight: 500;
  }
  .eui-accordion-content {
    background: #fff !important;
  }
`;

const DeliveryModes = ["Email", "SMS", "Both"];
const deniedStatus = ["Delivered", "Not Delivered"];

const Info = ({ label, value, reason }) => {
  if (!value) return null;
  return (
    <div className="d-flex align-items-center justify-content-between py-8">
      <Typography
        color="dark"
        shade="c200"
        className="mb-0"
        style={{
          whiteSpace: "nowrap",
        }}
      >
        {label}{" "}
        {label.toLowerCase() === "cancelled" && (
          <ReasonTooltipMsgShow reason={reason} />
        )}
      </Typography>

      <Typography
        color="dark"
        shade="c300"
        className="mb-0"
        style={{
          whiteSpace: "nowrap",
        }}
      >
        {value}
      </Typography>
    </div>
  );
};
const ReasonTooltipMsgShow = ({ reason }) => {
  return (
    <Tooltip width={200} tooltip={<>{reason}</>} placement="bottom">
      <Icon className="ml-6 mb-1" iconName="Info" size={16} />
    </Tooltip>
  );
};
const ViewDetail = ({
  setUpdateReportPopup,
  viewDetailModalData,
  showViewDetailModal,
  setShowViewDetailModal,
  title: initialTitle,
}) => {
  let title = "";
  if (viewDetailModalData?.xoxolink) {
    title = "xoxo reward link";
  } else {
    title = initialTitle;
  }
  const [loading, setLoading] = useState(false);
  const phoneNumber =
    viewDetailModalData?.receiver_phone_number ||
    viewDetailModalData?.recipient_phone ||
    "";
  const phoneCode =
    viewDetailModalData?.receiver_phone_code ||
    viewDetailModalData?.phone_code ||
    "";
  const details = [
    {
      title: "Recipient details",
      data: {
        Name: (
          <ToolTipText
            value={
              viewDetailModalData?.receiver_name ||
              viewDetailModalData?.name ||
              viewDetailModalData?.recipient_name
            }
          />
        ),
        Email: (
          <ToolTipText
            value={
              viewDetailModalData?.receiver_email ||
              viewDetailModalData?.email ||
              viewDetailModalData?.recipient_email
            }
          />
        ),
        "Phone Number": phoneNumber
          ? phoneCode?.includes("+")
            ? `${phoneCode} ${phoneNumber}`
            : `+${phoneCode} ${phoneNumber}`
          : "",
      },
    },
    {
      title: "Reward details",
      data: {
        "Value of Link": viewDetailModalData?.denomination_value,
        "Mode of Delivery":
          title === "xoxo reward link"
            ? DeliveryModes[viewDetailModalData?.delivery_method - 1]
            : viewDetailModalData?.mode_of_delivery,
        "Sent On": viewDetailModalData?.generation_date
          ? moment(viewDetailModalData?.generation_date, "YYYY-MM-DD").format(
              "D MMM, YYYY"
            )
          : viewDetailModalData?.issued_date
          ? moment(viewDetailModalData?.issued_date, "YYYY-MM-DD").format(
              "D MMM, YYYY"
            )
          : "",
        Expiry: viewDetailModalData?.expiry_date
          ? moment(viewDetailModalData?.expiry_date, "YYYY-MM-DD").format(
              "D MMM, YYYY"
            )
          : "",
        "Reward notes": (
          <ToolTipText value={viewDetailModalData?.notes} length={22} />
        ),
        "Current status": viewDetailModalData?.status,
        Campaign:
          viewDetailModalData?.campaignName &&
          viewDetailModalData?.products_count &&
          `${viewDetailModalData?.campaignName} - ${viewDetailModalData?.products_count} Vouchers`,
      },
    },
    {
      title: "Sender details",
      data: {
        "Sent By": (
          <ToolTipText value={viewDetailModalData?.sent_by} length={22} />
        ),
      },
    },
    {
      title: "Activity timeline",
      data: {
        "Delivered via SMS":
          viewDetailModalData?.sms_delivery_status ||
          viewDetailModalData?.sms_delivery_status
            ? viewDetailModalData?.issued_date
              ? moment(viewDetailModalData?.issued_date, "YYYY-MM-DD").format(
                  "MMM D, YYYY"
                )
              : viewDetailModalData?.generation_date
              ? moment(
                  viewDetailModalData?.generation_date,
                  "YYYY-MM-DD"
                ).format("MMM D, YYYY")
              : null
            : null,
        "Delivered via Email":
          viewDetailModalData?.mail_delievery_status ||
          viewDetailModalData?.mail_delivery_status
            ? viewDetailModalData?.issued_date
              ? moment(viewDetailModalData?.issued_date, "YYYY-MM-DD").format(
                  "MMM D, YYYY"
                )
              : viewDetailModalData?.generation_date
              ? moment(
                  viewDetailModalData?.generation_date,
                  "YYYY-MM-DD"
                ).format("MMM D, YYYY")
              : null
            : null,
        "Reward Sent": viewDetailModalData?.issued_date
          ? moment(viewDetailModalData?.issued_date, "YYYY-MM-DD").format(
              "MMM D, YYYY"
            )
          : viewDetailModalData?.generation_date
          ? moment(viewDetailModalData?.generation_date, "YYYY-MM-DD").format(
              "MMM D, YYYY"
            )
          : "",
      },
    },
  ];

  const statusDate = {};
  statusDate[viewDetailModalData?.status] =
    !deniedStatus.includes(viewDetailModalData?.status) &&
    viewDetailModalData?.date_modified
      ? moment(viewDetailModalData?.date_modified, "YYYY-MM-DD").format(
          "MMM D, YYYY"
        )
      : null;
  details[details.length - 1].data = {
    ...statusDate,
    ...details[details.length - 1].data,
  };
  const getTitle = () => {
    let title = "";
    if (viewDetailModalData?.sales_order_id) {
      title = `Order ID ${viewDetailModalData?.sales_order_id}`;
    } else if (viewDetailModalData?.voucher_code) {
      title = `Voucher ID ${viewDetailModalData?.voucher_code}`;
    } else if (viewDetailModalData?.id) {
      title = `Voucher ID ${viewDetailModalData?.id}`;
    } else if (viewDetailModalData?.xoxolink) {
      title = `Xoxo Link ${viewDetailModalData?.xoxolink}`;
    }
    return title;
  };
  const resendCancelHandleClick = (resendCancel) => {
    setUpdateReportPopup(resendCancel);
    setShowViewDetailModal(false);
  };
  return (
    <ViewDetailModal
      isOpen={showViewDetailModal}
      onClose={() => {
        setShowViewDetailModal(false);
      }}
      disableCloseButton={false}
      timeout={0}
      className="p-0"
    >
      <div className="d-flex flex-column justify-content-between h-100">
        <div>
          <Typography.H2 className="p-20">{getTitle()}</Typography.H2>
          <hr className="m-0" />{" "}
          <div className="d-flex align-items-center pt-20 px-20 pb-8">
            <Typography.LabelText component="span" className="mr-1">
              Status:
            </Typography.LabelText>{" "}
            <StatusChip
              value={
                viewDetailModalData?.status ||
                viewDetailModalData?.redemption_status
              }
              className="mr-20"
              style={{ width: "auto" }}
            />
            <Typography.LabelText component="span">
              Expiry Date
            </Typography.LabelText>
            :{" "}
            <Typography component="span">
              <Date value={viewDetailModalData?.expiry_date} />
            </Typography>
          </div>
          <div className="p-20">
            <Accordion
              onClick={() => {}}
              className="view-detail-accordain py-10"
              itemProps={{
                className: "view-detail-accordain-item",
              }}
            >
              {details.map((detail = {}, index) => {
                const hasValidValues = Object.values(detail.data).filter(
                  ($) => $
                ).length;

                return hasValidValues > 0 && detail ? (
                  <div title={detail.title} key={index}>
                    {Object.entries(detail.data).map(([key, value], idx) => {
                      return (
                        <Info
                          label={key}
                          value={value}
                          key={idx}
                          reason={viewDetailModalData.reason}
                        />
                      );
                    })}
                  </div>
                ) : null;
              })}
            </Accordion>
          </div>
        </div>
        <div
          className="d-flex justify-content-between p-20"
          style={{
            gap: "20px",
          }}
        >
          {loading ? (
            <div className="d-flex justify-content-center w-100">
              <CircularLoader />
            </div>
          ) : (
            <>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => {
                  resendCancelHandleClick("resend");
                }}
                className="w-100"
                disabled={
                  !isLinkResendable(
                    viewDetailModalData,
                    title === "xoxo reward link"
                  )
                }
              >
                Resend Reward
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => {
                  resendCancelHandleClick("cancel");
                }}
                className="w-100"
                disabled={!isLinkCancellable(viewDetailModalData)}
              >
                Cancel Reward
              </Button>
            </>
          )}
        </div>
      </div>
    </ViewDetailModal>
  );
};

export default ViewDetail;
